<script setup>
// Astra DS · ChipFecha — la fecha de un concierto, sobre la foto de la franja.
//
// Figma `Pattern/ChipFecha 2585:1094`, `Hoy=sí 2585:1082` / `Hoy=no 2585:1089`.
// Entrega `2026-10-21-portada-franja-y-player-en-cabecera.md`.
//
//   calendario 20 · «21 OCT» en `display/section` · HOY con su cuadrado rojo, o el año
//
// 42 de alto, contorno de 1 en `text/on-ink`, sin fondo, 14 a los lados y 10
// entre piezas. Va sobre arte, así que no cambia con el modo.
import { computed } from "vue";
import AstraIcon from "@/components/icons/AstraIcon.vue";
import { hoyEnMadrid } from "@/services/discos";

const props = defineProps({
  // «AAAA-MM-DD».
  fecha: { type: String, required: true },
});

const MESES = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];

const partes = computed(() => {
  const [y, m, d] = String(props.fecha).slice(0, 10).split("-").map(Number);
  return { dia: d, mes: MESES[(m || 1) - 1], anio: y };
});

// «Hoy» en hora de Madrid, que es la de las salas que se anuncian.
const esHoy = computed(() => String(props.fecha).slice(0, 10) === hoyEnMadrid());
</script>

<template>
  <span class="chip-fecha">
    <AstraIcon name="upcoming-shows" :size="20" />
    <span class="chip-fecha__fecha">{{ partes.dia }} {{ partes.mes }}</span>
    <span v-if="esHoy" class="chip-fecha__hoy">
      <i aria-hidden="true" />
      <span>Hoy</span>
    </span>
    <span v-else class="chip-fecha__anio">{{ partes.anio }}</span>
  </span>
</template>

<style scoped lang="scss">
@use "@/assets/scss/type" as t;

.chip-fecha {
  display: inline-flex;
  flex: none;
  align-items: center;
  gap: 10px;
  box-sizing: border-box;
  height: 42px;
  padding: 0 14px;
  border: 1px solid var(--color-text-on-ink);
  color: var(--color-text-on-ink);
}

.chip-fecha__fecha {
  @include t.display-section;
  white-space: nowrap;
}

// HOY: el cuadrado de 6 en `bg/accent` y la palabra, a 6.
.chip-fecha__hoy {
  display: inline-flex;
  align-items: center;
  gap: 6px;

  i {
    display: block;
    width: 6px;
    height: 6px;
    background: var(--color-bg-accent);
  }

  span {
    @include t.mono-label;
    text-transform: uppercase;
  }
}

.chip-fecha__anio {
  @include t.mono-label;
}
</style>
